import produce from 'immer';
import jwtDecode from 'jwt-decode';
import { POST_SIGN_IN_SUCCESS } from 'containers/SignIn/signin.constants';

import { 
  GET_USER_LIST_REQUEST,
  GET_USER_LIST_SUCCESS,
  GET_USER_LIST_FAILURE
} from './global.constants';
// const token = localStorage.getItem('token');
// const userState = token ? { user: jwtDecode(token) } : {};
export const initialState = {
  user: {},
  userList: [],
  userListLoading: false,
};

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = {}, action) =>
  produce(state, draft => {
    switch (action.type) {
      case POST_SIGN_IN_SUCCESS:
        const newToken = action.payload.data.access_token;
        localStorage.setItem('token', newToken);
        draft.user = jwtDecode(newToken);
        break;
      case GET_USER_LIST_REQUEST: {
        draft.userListLoading = true;
        break;
      }
      case GET_USER_LIST_FAILURE: {
        draft.userListLoading = false;
        break;
      }
      case GET_USER_LIST_SUCCESS: {
        const userList = action.payload.map(x => ({
          ...x,
          userId: parseInt(x.userId, 0)
        }));
        draft.userList = userList;
        draft.userListLoading = false;
        break;
      }
    }
  });

export default appReducer;
